import React from "react"
import Heading from "@components/heading"
import RichText from "@components/rich-text"
import * as styles from "./values.module.css"
import getValue from "get-value"
import { getImageData } from '@utils/image'
import CTA from "@components/blocks/cta"
import Image from "@components/image"

const Values = ({ title, values, valueImage }) => {
  const imageTitle = getValue(valueImage, "title", { default: title })
  const imageAssetId = getValue(valueImage, 'image.asset._ref') || getValue(valueImage, 'image.asset._id')
  const imageData = getImageData(imageAssetId, { width: 1000, height: 1000, fit: 'crop' })

  return (
    <div className="grid lg:grid-cols-12 gap-5 md:gap-y-12 md:gap-x-10">
      <div className="order-2 md:col-span-6 lg:order-1 p-5 md:p-10 bg-sage rounded-xl">
        <Heading level="2" className="hidden mb-8 lg:inline-block">{title}</Heading>
        <ValueList valueList={values} />
      </div>
      <div className="order-1 md:col-span-6 lg:order-2">
        <Heading level="2" className="block mb-4 text-center lg:hidden">{title}</Heading>
        {imageAssetId && imageData && (
          <Image
            className="rounded-xl h-96 lg:h-full"
            image={imageData}
            alt={imageTitle}
            fadeIn={false}
            loading="eager"
          />
        )}
      </div>
    </div>
  )
}

const ValueList = ({ valueList }) => (
  <ol className="grid gap-2.5 md:grid-cols-2 lg:grid-cols-1">
    {
      valueList.map((item, index) => (
        item._type === "cta" ? (
          <li
            className=""
            key={item._key}
          >
            <CTA cta={item} />
          </li>
        ) : (
          <li
            className=""
            key={item._key}
            style={{
              "--counter": `'${index + 1 > 9 ? index + 1 : `0${index + 1}`}'`,
            }}
          >
            <Heading
              level="3"
              className={`lining-nums subquote mb-2.5 md:mb-5 ${styles.valueItemHeading}`}
            >
              {item.title}
            </Heading>
            <RichText childrenHTML={item.description} className="text-sm" />
          </li>
        )
      ))}
  </ol>
)

export default Values
